import _regeneratorRuntime from "/Users/anitalu/Desktop/internship/anitalu724.github.io/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _createForOfIteratorHelper from "/Users/anitalu/Desktop/internship/anitalu724.github.io/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _asyncToGenerator from "/Users/anitalu/Desktop/internship/anitalu724.github.io/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { TextDrawer, validTypes } from "./TextDrawer";
export function loadTextShape(_x) {
  return _loadTextShape.apply(this, arguments);
}

function _loadTextShape() {
  _loadTextShape = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(engine) {
    var drawer, _iterator, _step, type;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          drawer = new TextDrawer();
          _iterator = _createForOfIteratorHelper(validTypes);
          _context.prev = 2;

          _iterator.s();

        case 4:
          if ((_step = _iterator.n()).done) {
            _context.next = 10;
            break;
          }

          type = _step.value;
          _context.next = 8;
          return engine.addShape(type, drawer);

        case 8:
          _context.next = 4;
          break;

        case 10:
          _context.next = 15;
          break;

        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](2);

          _iterator.e(_context.t0);

        case 15:
          _context.prev = 15;

          _iterator.f();

          return _context.finish(15);

        case 18:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 12, 15, 18]]);
  }));
  return _loadTextShape.apply(this, arguments);
}